import React, { createContext, useState, useContext, PropsWithChildren } from 'react';
import { User } from '../../user/models/user';

export type UserContext = {
  currentUser: User | null;
  login: (value: User) => void;
  logout: () => void;
};

const AuthContext = createContext<UserContext | null>(null);

const AuthenticationProvider = ({ children }: PropsWithChildren<{}>) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);

  const currentUserContext: UserContext = {
    currentUser,
    login: (user: User) => setCurrentUser(user),
    logout: () => setCurrentUser(null),
  };

  return (
    <AuthContext.Provider value={currentUserContext}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthenticationProvider;

export const useAuthentication = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthentication must be used within AuthenticationProvider');
  }
  return context;
};
